import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navbarBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textColor = isHome && !scrolled
    ? 'text-background-50'
    : 'text-foreground-800';

  const logoColor = isHome && !scrolled
    ? 'text-background-50'
    : 'gold-gradient';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navbarBg} ${scrolled ? 'border-b border-background-200/60' : ''}`}>
      <div className="container-custom">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className={`font-heading text-2xl md:text-3xl font-bold tracking-wider whitespace-nowrap ${logoColor}`}>
            豪门国际
          </Link>

          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`relative px-4 py-2 text-sm font-medium whitespace-nowrap rounded-full transition-all duration-300 cursor-pointer
                    ${isHome && !scrolled
                      ? `${textColor}/80 hover:${textColor}`
                      : `${textColor}/70 hover:text-foreground-950`
                    }
                    ${isActive ? (isHome && !scrolled ? `${textColor} font-semibold` : 'text-primary-600 font-semibold') : ''}
                  `}
                >
                  {link.label}
                  {isActive && (
                    <span className={`absolute bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 rounded-full ${isHome && !scrolled ? 'bg-background-50' : 'bg-primary-500'}`} />
                  )}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center space-x-3">
            <Link
              to="/about"
              className={`px-5 py-2 text-sm font-medium whitespace-nowrap rounded-full border transition-all duration-300 cursor-pointer
                ${isHome && !scrolled
                  ? 'border-background-50/40 text-background-50 hover:bg-background-50/15'
                  : 'border-primary-400 text-primary-600 hover:bg-primary-50'
                }
              `}
            >
              联系我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${textColor}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      <div className={`md:hidden transition-all duration-300 overflow-hidden ${mobileOpen ? 'max-h-screen pb-4' : 'max-h-0'}`}>
        <div className="container-custom bg-background-50/98 backdrop-blur-md rounded-2xl border border-background-200/60 py-3 px-2">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-4 py-3 text-sm font-medium rounded-xl transition-colors duration-200 cursor-pointer whitespace-nowrap
                  ${isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}
                `}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/about"
            className="block mt-2 mx-3 px-5 py-2.5 text-sm font-medium text-center whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            联系我们
          </Link>
        </div>
      </div>
    </nav>
  );
}